import { Route, Redirect } from 'react-router-dom'
import React, { Fragment, useContext } from 'react'
import { PageContext } from './Context/PageProvider'
import { hasUserPermission } from './Helper'

const ProtectedRoute = ({ component: Component, ...rest }) => {
    const context = useContext(PageContext)
    const user = context.user
    const checkPermission = hasUserPermission(user, 'manage-messages')
    return (
        <Fragment>
            <Route
                {...rest}
                render={(props) => (
                    user && rest.path === '/login' ?
                        <Redirect to="/" />
                        : user ?
                            <Component {...rest} {...props} context={context} />
                            : <Fragment> <Component {...rest} {...props} context={context} /> <Redirect to='/login' /> </Fragment>
                )} />
        </Fragment >

    )
}

export default ProtectedRoute